import { Component, inject } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { ModalService } from '../../../../services/modals/modal.service';

@Component({
  selector: 'app-credit-card-successfully',
  imports: [ButtonModule],
  templateUrl: './credit-card-successfully.component.html',
  styleUrl: './credit-card-successfully.component.scss'
})
export class CreditCardSuccessfullyComponent {

  private readonly modalService = inject(ModalService);

  onDone() {
    // console.log('hi')
    this.modalService.closeModal('credit-card-successfully');
  }
}
